const angular = require('angular');

const TrackMyOrderService = require('./trackmyorder.service');
const { trackMyOrderGuestFormComponentDefinition } = require('./trackmyorder-guest-form.component');

angular.module('wowApp.shop')
    .service('TrackMyOrderService', ['Restangular', TrackMyOrderService])
    .component('wowTrackmyorderGuestForm', trackMyOrderGuestFormComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/index.js